import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  typography: {
    fontFamilyRegular: "JohnsonsBaby",
    secondaryFont: "Poppins",
    fontFamily: "JohnsonsBaby, sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontDisplay: "swap",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1140,
      xl: 1920,
    },
  },
  palette: {
    brand: {
      primary: {
        key: "#0D5BA8",
        light: "#B8DAD8",
        medium: "#004E5A",
        dark: "#003138",
      },
      secondary: {
        key: "#B1DBF0",
        light: "",
        medium: "",
        dark: "#AC68E5",
      },
      terciary: {
        key: "#FCC800",
        light: "#b1dbf0",
        medium: "",
        dark: "",
      },

    },
    neutral: {
      primary: {
        key: "#1B1B19",
        light: "#FFFFFF",
        medium: "#EEEEEE",
        dark: "#969696",
      },
    },
    feedback: {
      success: {
        key: "#62980E",
        light: "#F0FFDA",
        medium: "#62980E",
        dark: "#62980E",
      },
      error: {
        key: "#DB3939",
        light: "#FFF1F3",
        medium: "#DB3939",
        dark: "#DB3939",
      },
    },
    transparent: "transparent",
  },
  modalGradient: "rgba(0,0,0,0.70)",
  transition: "all ease 0.2s",
});

export default theme;
